// src/Smart/Organisation/useServicesFormLogic.ts
import { useEffect, useState } from "react";

import { BusinessService } from "0.Mine/3.Interfaces/Services";

export interface ServicesFormLogicProps {
  initialValue: BusinessService[];
  updateBusinessData: (data: BusinessService[]) => void;
}

export const useServicesFormLogic = ({
  initialValue,
  updateBusinessData,
}: ServicesFormLogicProps) => {
  const [treatments, setTreatments] = useState<BusinessService[]>(initialValue);
  // Update business data whenever treatments change
  useEffect(() => {
    updateBusinessData(treatments);
  }, [treatments, updateBusinessData]);

  const handleAddTreatment = async (treatment: BusinessService) => {
    setTreatments([...treatments, treatment]);
  };

  const handleDeleteTreatment = (index: number) => {
    const updatedTreatments = treatments.filter((_, i) => i !== index);
    setTreatments(updatedTreatments);
    // Calling updateBusinessData here may be redundant because useEffect
    // will also run after state update. Consider removing one of them.
    updateBusinessData(updatedTreatments);
  };

  const handleReorderTreatments = (newTreatments: BusinessService[]) => {
    setTreatments(newTreatments);
  };

  // Add update function to handle editing
  const handleUpdateTreatment = (updatedTreatment: BusinessService) => {
    const updatedTreatments = treatments.map((treatment) =>
      treatment._id === updatedTreatment._id ? updatedTreatment : treatment
    );
    setTreatments(updatedTreatments);
  };

  return {
    treatments,
    handleAddTreatment,
    handleDeleteTreatment,
    handleReorderTreatments,
    handleUpdateTreatment, // Add this to the returned object
  };
};
